import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconReact = ({
  title = "React",
  viewBoxWidth = 56,
  viewBoxHeight = 51,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <g transform="translate(0 -2)" fill="none" fillRule="evenodd">
      <path d="M0 0h56v56H0z" />
      <circle fill="#00D8FF" fillRule="nonzero" cx="28" cy="27.627" r="4.993" />
      <path
        d="M28 39.066c-7.012 0-13.14-.826-17.725-2.397-2.974-1.015-5.5-2.368-7.3-3.91C1.064 31.13.05 29.349.05 27.628c0-3.302 3.62-6.535 9.698-8.644 4.973-1.73 11.458-2.695 18.242-2.695 6.664 0 13.06.935 18.004 2.646 2.894.994 5.331 2.287 7.062 3.72 1.88 1.571 2.874 3.292 2.874 4.973 0 3.432-4.048 6.903-10.573 9.061C40.742 38.22 34.575 39.066 28 39.066zm0-20.391c-6.436 0-12.801.935-17.456 2.556-5.59 1.95-8.097 4.616-8.097 6.396 0 1.85 2.695 4.764 8.604 6.784 4.337 1.482 10.205 2.268 16.949 2.268 6.326 0 12.225-.796 16.611-2.258 6.137-2.04 8.942-4.954 8.942-6.794 0-.945-.716-2.059-2.02-3.143-1.501-1.253-3.69-2.397-6.305-3.302C40.523 19.57 34.406 18.675 28 18.675z"
        fill="#00D8FF"
        fillRule="nonzero"
      />
      <path
        d="M16.67 52.514c-1.014 0-1.91-.22-2.665-.657-2.855-1.651-3.85-6.405-2.646-12.722.985-5.182 3.392-11.27 6.784-17.148 3.332-5.769 7.33-10.842 11.28-14.273 2.307-2.01 4.644-3.482 6.753-4.258 2.298-.845 4.287-.845 5.74-.01 2.974 1.711 3.958 6.963 2.566 13.687-.985 4.775-3.332 10.534-6.615 16.233-3.501 6.068-7.28 10.962-10.931 14.154-2.368 2.07-4.805 3.581-7.033 4.367-1.163.418-2.258.627-3.232.627zm2.497-29.93l1.035.597c-3.213 5.57-5.59 11.548-6.505 16.402-1.104 5.819-.04 9.32 1.492 10.205.378.22.875.338 1.482.338 1.98 0 5.092-1.253 8.693-4.396 3.452-3.014 7.062-7.709 10.434-13.547 3.163-5.481 5.411-10.992 6.346-15.517 1.303-6.336.18-10.216-1.422-11.14-.816-.468-2.139-.408-3.73.178-1.84.677-3.92 2-6.008 3.82-3.75 3.263-7.58 8.116-10.782 13.667l-1.035-.607z"
        fill="#00D8FF"
        fillRule="nonzero"
      />
      <path
        d="M39.33 52.544c-2.706 0-6.138-1.632-9.719-4.715-3.998-3.442-8.066-8.564-11.468-14.443-3.342-5.769-5.73-11.767-6.734-16.91-.587-3.003-.696-5.758-.318-7.977.417-2.417 1.402-4.137 2.864-4.983 2.964-1.72 8.007.05 13.14 4.615 3.64 3.233 7.46 8.147 10.752 13.836 3.511 6.068 5.869 11.787 6.804 16.542.607 3.083.706 5.948.278 8.275-.457 2.477-1.492 4.238-2.984 5.103-.746.438-1.631.657-2.616.657zM20.211 32.193c3.222 5.57 7.221 10.613 10.961 13.825 4.486 3.86 8.047 4.695 9.589 3.8 1.601-.925 2.775-4.715 1.561-10.842-.895-4.496-3.153-9.966-6.535-15.805-3.173-5.48-6.823-10.186-10.275-13.25C20.68 5.626 16.76 4.66 15.16 5.586c-.816.468-1.423 1.651-1.711 3.322-.328 1.93-.229 4.397.308 7.112.955 4.884 3.243 10.623 6.456 16.174z"
        fill="#00D8FF"
        fillRule="nonzero"
      />
    </g>
  </Svg.Icon>
)

export default IconReact
